<template>
  <div>
    <div class="mb-4" style="display: flex; gap: 1em">
      <div>
        <b-input-group size="sm">
          <b-form-input
            id="filter-input"
            v-model="filter"
            type="search"
            placeholder="Search..."
          ></b-form-input>

          <b-input-group-append>
            <!-- <b-button :disabled="!filter" @click="filter = ''">Clear</b-button> -->
            <span class="material-icons-outlined"> search </span>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div>
        <b-form-select
          id="initial-sort-select"
          v-model="filterOn"
          value-field="key"
          text-field="label"
          :options="fields"
          size="sm"
        ></b-form-select>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :select-mode="selectMode"
      selectable
      stacked="md"
      show-empty
      ref="selectableTable"
      small
      @filtered="onFiltered"
      @row-selected="onRowSelected"
    >
      <template #head(select)>
        <span
          class="material-icons-outlined"
          style="cursor: pointer"
          @click="selectAll"
        >
          {{
            selected.length == items.length
              ? "check_box"
              : "check_box_outline_blank"
          }}
        </span>
      </template>
      <template #cell(select)="{ rowSelected, item }">
        <div style="display: inline-flex">
          <template v-if="rowSelected">
            <span class="material-icons-outlined"> check_box </span>
          </template>
          <template v-else>
            <span class="material-icons-outlined">
              check_box_outline_blank
            </span>
          </template>
          <span class="material-icons-outlined" :id="`edit-${item.mac}`">
            more_vert
          </span>
          <b-tooltip
            :target="`edit-${item.mac}`"
            triggers="hover"
            variant="light"
          >
            <div
              style="
                padding: 0.5em;
                display: flex;
                flex-direction: column;
                gap: 0.5em;
              "
            >
              <div
                style="
                  display: flex;
                  gap: 1em;
                  align-items: center;
                  cursor: pointer;
                "
              >
                <span class="material-icons-outlined"> visibility </span>
                View
              </div>
              <div
                style="
                  display: flex;
                  gap: 1em;
                  align-items: center;
                  cursor: pointer;
                "
              >
                <span class="material-icons-outlined"> edit_note </span>
                Edit
              </div>
              <div
                style="
                  display: flex;
                  gap: 1em;
                  align-items: center;
                  cursor: pointer;
                "
              >
                <span class="material-icons-outlined"> content_copy </span>
                Copy
              </div>
            </div>
          </b-tooltip>
        </div>
      </template>
      <template #cell(priority)="{ value }">
        <div style="display: inline-flex">
          <b-badge pill variant="danger">{{ value }}</b-badge>
        </div>
      </template>
    </b-table>
    <div
      style="
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 1em;
      "
    >
      <div>
        <b-form-select
          id="per-page-select"
          v-model="perPage"
          :options="pageOptions"
          size="sm"
        ></b-form-select>
      </div>
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="pagination-table my-0"
          page-class="active-a"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filter: null,
      filterOn: [],
      totalRows: 1,
      perPage: 5,
      currentPage: 1,
      pageOptions: [
        { value: 1, text: "1 Item" },
        { value: 3, text: "3 Item" },
        { value: 5, text: "5 Item" },
      ],
      selected: [],
      selectMode: "multi",
      items: [],
      fields: [
        {
          key: "select",
          label: "",
          sortable: false,
        },
        {
          key: "priority",
          label: "Priority",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          formatter: (value, key, item) => {
            return value ? "🟢" : "🔴";
          },
          class: "text-center",
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: "name", label: "Asset Name", sortable: true },
        { key: "mac", label: "MAC ID", sortable: true },
        { key: "category", label: "Category", sortable: true },
        { key: "check_in", label: "Check in", sortable: true },
        { key: "location", label: "Location", sortable: true },
        {
          key: "duration",
          label: "Duration",
          sortable: true,
          formatter: (value, key, item) => {
            return value + " hr.";
          },
        },
        {
          key: "condition",
          label: "Condition",
          sortable: true,
          formatter: (value, key, item) => {
            return value + "%";
          },
        },
        { key: "last_checkup", label: "Last Checkup Date", sortable: true },
        { key: "expiration_date", label: "Expiration Date", sortable: true },
      ],
    };
  },
  mounted() {
    this.genData();
    this.totalRows = this.items.length;
  },
  methods: {
    genData() {
      let data = [];
      for (let i = 0; i < 5; i++) {
        let newA = {
          select: false,
          priority: "3-High",
          status: Math.floor(Math.random() * 2),
          name: `sofa ${i + 1}`,
          mac: `AC23456${i}`,
          category: "wood",
          check_in: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          location: "building a / floor 1 / room 1",
          duration: (Math.random() * 3).toFixed(2),
          condition: 95,
          last_checkup: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          expiration_date: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        };
        data.push(newA);
      }
      this.items = data;
    },
    selectAll() {
      console.log(this.selected.length, this.items.length);
      if (this.selected.length == this.items.length) {
        this.$refs.selectableTable.clearSelected();
      } else {
        this.$refs.selectableTable.selectAllRows();
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style>
</style>